<template>
<!-- 店铺红包 -->
<div class="viewContainer">
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="活动时间：" style="display:flex;width:23%">
            <el-date-picker type="daterange" v-model="value1" value-format="yyyy-MM-dd" @change="changetime(1)"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:90%"/>
          </el-form-item>
          <el-form-item style="margin-right: 10px;">
            <el-button type="danger" @click="findinfo()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <div class="model_section">
      <p class="model_top_title">店铺红包</p>
      <el-button type="danger" @click="showadd()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </div>
    <div class="table_container">
      <el-table :data="envelopeList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="活动时间" align="center">
          <template scope="scope">{{scope.row.begindate}} - {{scope.row.enddate}}</template>
        </el-table-column>
        <el-table-column label="红包总金额（元）" align="center">
          <template scope="scope">{{scope.row.totalprice}}</template>
        </el-table-column>
        <el-table-column label="红包数量（个）" align="center">
          <template scope="scope">{{scope.row.totalcount}}</template>
        </el-table-column>
        <!-- <el-table-column label="已发放数量(个)" align="center">
          <template scope="scope">{{scope.row.CPhone}}</template>
        </el-table-column> -->
        <el-table-column label="已发放数量(个)" align="center">
          <template scope="scope"><b style="color:#409EFF;" @click="handleSeeLlmx(scope.row)">{{scope.row.usedcount}}</b></template>
        </el-table-column>
        <el-table-column label="已发放金额(元)" align="center">
          <template scope="scope">{{scope.row.usedprice}}</template>
        </el-table-column>
        <el-table-column label="退款金额(元)" align="center">
          <template scope="scope">{{scope.row.refundprice}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <!-- 红包状态 1=草稿 5=待开始 10=进行中 20=已结束 30=已关闭 -->
          <template scope="scope">
            {{scope.row.status==1?'草稿':scope.row.status==5?'待开始':scope.row.status==10?'进行中':scope.row.status==20?'已结束':'已关闭'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template scope="scope">
            <span class="handle" @click="handleUpper(scope.row, 1)" v-show="scope.row.status==1"> <i class="el-icon-circle-check"/> 开启 </span>
            <span class="handle" @click="handleUpper(scope.row, 2)" v-show="scope.row.status==5"> <i class="el-icon-circle-close"></i> 关闭 </span>
            <span class="handle" @click="handleUpper(scope.row, 4)" v-show="scope.row.status==10"> <i class="el-icon-remove-outline"/> 结束 </span>
            <span class="handle" @click="showadd(scope.row,1)" v-show="scope.row.status==1"><i class="el-icon-edit-outline"></i> 编辑</span>
            <span class="handle" @click="showadd(scope.row,2)" v-show="scope.row.status!=1"> <i class="el-icon-view"/> 查看 </span>
            <span class="handle" @click="handleUpper(scope.row, 3)" v-show="scope.row.status==1"> <i class="el-icon-delete"/> 删除 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 领取明细 右侧抽屉组件 -->
  <el-drawer title="红包领取明细" custom-class="registrationRecord" :visible.sync="visibleLqmx" size="30%">
    <el-table :data="lqmxList" border>
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="phone" label="用户" align="center"/>
      <el-table-column property="price" label="金额（元）" align="center"/>
      <el-table-column property="receivetime" label="领取时间" align="center"/>
    </el-table>
    <!-- 领取明细-分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleLqmx"
    :current-page="pageIndexLqmx" :page-size="10" :total="totalLqmx" style="float: right; margin-top: 10px"/>
  </el-drawer>
  
  <!-- 红包配置 -->
  <el-dialog title="红包配置" :visible.sync="dialogVisibleshenhe" :before-close="handleClose" center width="45%">
    <el-form>
      <el-form-item label="活动时间：" style="display:flex;width:50%">
        <el-date-picker type="daterange" v-model="value2" value-format="yyyy-MM-dd" @change="changetime(2)" :picker-options="pickerOptionsStart"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%" :disabled="disabledHB"/>
      </el-form-item>
      <el-form-item label="红包配置：" style="display:flex;width:100%">
        <el-form-item v-for="(item, index) in formItems" :key="index">
          <el-row :gutter="16" style="margin-bottom: 10px;">
            <el-col :span="5">
              <el-form-item prop="price">
                <el-input type="number" v-model="item.price" placeholder="单个金额" maxlength="6" clearable :disabled="disabledHB"
                onkeyup="value=value.replace(/[^\d]/g,'');">
                  <i slot="suffix" style="margin-right: 10px;">元</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">✖</el-col>
            <el-col :span="5">
              <el-form-item prop="count">
                <el-input v-model="item.count" placeholder="红包数量" maxlength="6" clearable :disabled="disabledHB"
                onkeyup="value=value.replace(/[^\d]/g,'');">
                  <i slot="suffix" style="margin-right: 10px;">个</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="greeting">
                <el-input v-model="item.greeting" placeholder="红包贺词最多10个字" maxlength="10" clearable :disabled="disabledHB"/>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-button v-show="!disabledHB && index > 0" type="danger" size="small" @click="removeItem(index)">删除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-button type="danger" size="small" @click="addItem" v-show="!disabledHB">添加配置</el-button>
      </el-form-item>
      <p>红包总额：<b>{{ RIntention }} 元</b></p>
    </el-form>
    <ul style="line-height: 26px;color: #F56C6C;">
      <li>重要提示：</li>
      <li>1.单个红包金额不低于6.66元;</li>
      <li>2.可配置多组红包，进行随机配置;</li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleshenhe = false">{{disabledHB?"关闭":"取消"}}</el-button>
      <el-button type="danger" @click="adopt()" v-show="!disabledHB">确定</el-button>
    </span>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">确定要支付红包费用后开启新人红包活动吗？</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">{{chognzhitishi}}</p>
    </div>
    <div style="text-align:center;">
      <el-button @click="chongzhidialog = false">取消</el-button>
      <el-button type="danger" @click="quchongzhi()">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity } from '../../api/newOss';
import { activityGetlist, activityAdd, activityGetinfo, activityEdit, receiveGetlist, activityDel, activityFinish, activityClose, activityStart } from "../../api/attractInvestment";
export default {
  name: "shopRedPacketActivity",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      value1: "", // 活动时间
      date1: "",
      date2: "",
      
      envelopeList: [],
      RIntention: 0,
      pageIndex: 1,
      total: 0,
      comId: "", // 选中行id
      dialogVisibleshenhe: false, // 红包配置
      disabledHB: false, // 红包配置-禁用
      value2: "", // 活动时间
      date3: "",
      date4: "",
      formItems: [
        {
          rpid: 0,
          price: '',
          count: '',
          greeting: ''
        }
      ],
      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      visibleLqmx: false, // 领取明细-抽屉
      lqmxList: [], // 领取明细-列表
      pageIndexLqmx: 1,
      totalLqmx: 0,
      
      dialogVisibleadd: false,
      bbid:'',  //店铺id
      options1: [],

      fufeidialog: false, // 确认提示
      zysj: 0, // 金额
      chongzhidialog: false, // 充值提示
      chognzhitishi: '', // 提示文案

    };
  },
  methods: {
    // 活动时间
    changetime(type) {
      if(type==1){ // 检索区域
        if(this.value1+""=="null"){
          this.value1 = ["",""]
        }
        this.date1 = this.value1[0];
        this.date2 = this.value1[1];
      }else{ // 弹框
        if(this.value2+""=="null"){
          this.value2 = ["",""]
        }
        this.date3 = this.value2[0];
        this.date4 = this.value2[1];
      }
    },
    init() {
      var obj = {
        // userId: localStorage.Id, // 当前登陆人id
        businessType: 1, // 业务类型 1=店铺 2=合伙人
        businessId: this.bbid, // 业务ID（businessType=1时传店铺ID businessType=2时不用传）
        beginDate: this.date1, // 红包活动起始日期
        endDate: this.date2, // 红包活动截止日期
        pid: 0, // 省份ID
        cid: 0, // 城市ID
        scid: 0, // 区县ID
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      activityGetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.envelopeList = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        } else {
          this.envelopeList = [];
          this.total = 0;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 查询
    findinfo() {
      this.pageIndex = 1;
      this.init();
    },
    // 重置
    fnReset() {
      this.value1 = '';
      this.date1 = '';
      this.date2 = '';
    },
    // 新增/编辑
    showadd(row,type) {
      this.dialogVisibleshenhe=true;
      if(row){
        this.comId = row.rpaid; // 红包活动ID
        // 回显接口
        let obj = {rpaId: this.comId,};
        activityGetinfo(obj).then(data => {
          let dataInfo = data.resultObj.info; // 红包活动信息
          this.comId=dataInfo.rpaid;
          this.date3=dataInfo.begindate;
          this.date4=dataInfo.enddate;
          this.value2 = [this.date3,this.date4];
          this.RIntention=dataInfo.totalprice; // 红包总金额 单位：元
          // totalcount=dataInfo.totalcount; // 红包总数量 单位：个
          this.formItems = data.resultObj.redpackets; // 红包信息集合
        })
        if(type==1){ // 编辑回显
          this.disabledHB=false;

        }else{ // 查看回显
          this.disabledHB=true;
        }
      }else{
        this.disabledHB=false;
        this.comId = "";
        this.value2 = ""; // 活动时间
        this.date3 = "";
        this.date4 = "";
        this.formItems = [
          {
            price: '',
            count: '',
            greeting: ''
          }
        ];
        
      }
    },
    // 添加配置
    addItem() {
      // 验证所有输入框是否为空
      if (this.validateInputs()) {
        // 添加新的配置项
        this.formItems.push({
          price: '',
          count: '',
          greeting: ''
        });
      }
    },
    // 删除配置
    removeItem(index) {
      // 删除指定索引的配置项
      this.formItems.splice(index, 1);
    },
    // 校验
    validateInputs() {
      for (const item of this.formItems) {
        if (!item.price || !item.count || !item.greeting) {
          this.showAlert('请确保所有输入框都不为空！');
          return false;
        }
        if (item.price<6.66) {
          this.showAlert('单个金额不能低于6.66元');
          return false;
        }
      }
      return true;
    },
    // 确定
    adopt() {
      if (this.value2 == "") {
        this.showAlert('请选择活动时间');
        return false;
      }
      if(this.validateInputs()){
        if(this.comId){ var hbid = this.comId; }
        var obj = {
          rpaid: hbid, // 红包活动ID
          rpatype: 1, // 红包活动类型1=店铺红包 2=合伙人红包
          shopid: this.bbid, // 店铺ID（raptype=1时必传）
          pid: 0, // 省份ID
          cid: 0, // 城市ID
          scid: 0, // 区县ID
          begindate: this.date3, // 开始日期
          enddate: this.date4, // 截止日期
          redpackets: this.formItems, // 红包信息集合
          // RIntention: this.RIntention,
        };
        let thisApi = this.comId==''?activityAdd:activityEdit;
        thisApi(obj).then(data => {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
            this.init();
            this.dialogVisibleshenhe = false;
            this.RIntention = "";
          }
        });
        // this.$swal({
        //   type: "warning",
        //   text: "是否确定配置红包",
        //   showCancelButton: true,
        //   cancelButtonText: "取消",
        //   confirmButtonText: "确定"
        // }).then(res => {
        //   if (res.value) {
            
        //   }
        // });
      }
    },
    handleClose() {
      this.dialogVisibleshenhe = false;
    },
    // 红包领取明细
    handleSeeLlmx(row) {
      this.comId = row.rpaid // 红包活动ID
      this.getLlmx();
      this.visibleLqmx = true;
    },
    // 领取明细-列表
    getLlmx(){
      let addParams = {
        rpaId: this.comId, // 红包活动ID
        pageIndex: this.pageIndexLqmx, // 页码
        pageSize: 10, // 条数
      };
      receiveGetlist(addParams).then(data => {
        if (data.resultCode == 1) {
          this.lqmxList = data.resultObj.list;
          this.totalLqmx = data.resultObj.totalcount;
        } else {
          this.lqmxList = [];
          this.totalLqmx = 0;
        }
      })
    },
    // 领取明细-分页
    handleLqmx(val) {
      this.pageIndexLqmx = val;
      this.getLlmx();
    },
    // 去充值
    quchongzhi(){
      this.$router.push({
        path: "/vmacount", // 跳转店铺钱包
        query: { shopid: this.bbid }
      });
    },
    // 确定
    qdfufeu(){
      this.fufeidialog=false;
      activityStart('', this.comId).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.init();
        }else if(data.resultCode == 4) {
          this.chongzhidialog=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 删除3 & 结束4 & 开启/关闭
    handleUpper(row, type) {
      this.comId = row.rpaid; // 红包活动ID
      if(type==1){ // 开启
        this.zysj = row.totalprice; // 红包总金额
        this.fufeidialog=true;
        // this.$swal({
        //   type: "warning",
        //   text: "重要信息，您确定开启吗？",
        //   showCancelButton: true,
        //   reverseButtons: true, // 添加这一行来反转按钮顺序
        //   cancelButtonText: "取消",
        //   confirmButtonText: "确定"
        // }).then(res => {
        //   if (res.value) {
            
        //   }
        // });
      }else{ // 删除3 & 结束4 & 关闭2
        this.$swal({
          type: "warning",
          text: type==3?'重要信息，你确定要删除吗？':type==4?'你确定要结束吗？':'您确定关闭吗？',
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then(res => {
          if (res.value) {
            let thisApi = type==3?activityDel:type==4?activityFinish:activityClose;
            thisApi('', row.rpaid).then(data => {
              if (data.resultCode == 1) {
                this.showAlert('操作成功', 'success');
                this.init();
              }
            });
          }
        });
      }
    },
    // 初始化查店铺
    getshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id;     //店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {      //默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺。');
            return false;
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.init();
      this.dialogVisibleadd = false;
    },
    // 计算单个金额乘以红包数量，并累加结果
    calculateTotal() {
      let total = 0;
      this.formItems.forEach(item => {
        if (item.price && item.count) {
          const price = parseFloat(item.price);
          const count = parseFloat(item.count);
          if (!isNaN(price) && !isNaN(count)) {
            total += price * count;
          }
        }
      });

      this.RIntention = total.toFixed(2); // 更新累加结果
    },
    
  },
  watch: {
    'formItems': {
      handler(newVal, oldVal) {
        this.calculateTotal(); // 每当formItems变化时重新计算总和
      },
      deep: true // 监听数组内部的变化
    }
  },
  mounted() {
    this.getshop(); // 初始化查店铺
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// shopRedPacketActivity.vue?6de3d5af